import { Button } from '@change/ds-core-ui/next';

import { useResetCache } from './hooks/useResetCache';

export function PetitionGuideResetCacheButton(): React.JSX.Element | null {
	const {
		data: { userIsStaff },
		actions: { resetCache },
	} = useResetCache();

	if (!userIsStaff) {
		return null;
	}

	return (
		<div className="container mb-5">
			<Button type="button" onClick={resetCache}>
				Reset Cache (staff view only)
			</Button>
		</div>
	);
}
